exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loader[data-v-6192fcc7] {\n\tborder: 5px solid #f3f3f3; /* Light grey */\n\tborder-top: 5px solid #3498db; /* Blue */\n\tborder-radius: 50%;\n\twidth: 30px;\n\theight: 30px;\n\tanimation: spin-data-v-6192fcc7 2s linear infinite;\n}\n@keyframes spin-data-v-6192fcc7 {\n0% { transform: rotate(0deg);\n}\n100% { transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6192fcc7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/layout_12.vue
// module id = 777
// module chunks = 0